<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script setup>
import { ref } from "vue";

import BaseModal from "@/components/BaseModal/index.vue"
import { usePackaging } from "@/composables/usePackaging"
import NBRadioGroup from "@/app/Checkout/components/common/NBRadioGroup/index.vue"

const isModalOpen = ref(false)
const { wrappingOptions, showWrappingSelection, selectedWrappingLabel, selectedWrappingOption } = usePackaging()
const openOverlay = () => {
  isModalOpen.value = true
}
const handleSelect = (val) => {
  isModalOpen.value = false
  selectedWrappingOption.value = val
}
</script>
